var __jsx = React.createElement;
import React from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faFileLines } from "@fortawesome/pro-regular-svg-icons";
import SubmissionStatusBadge from "./AllACRSubmissions/SubmissionStatusBadge";
import { getReportDisplayTitle } from "../../utils/acrUtils";
import { format, parseISO } from "date-fns";
var SubmissionPreviewCard = function SubmissionPreviewCard(_ref) {
  var report = _ref.report,
    onClick = _ref.onClick;
  var submission = report.acr_submission;
  if (!submission) return null;
  var studyDescription = getReportDisplayTitle(report);
  var examDate = report !== null && report !== void 0 && report.updated_at ? format(parseISO(report === null || report === void 0 ? void 0 : report.updated_at), "MM/dd/yyyy, h:mma") : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-4 bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-8 p-4 items-start cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-600 transition-all duration-200",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faFileLines,
    className: "text-gray-700 dark:text-gray-300 mt-1 h-5 w-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-3 min-w-0 flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start min-w-0 flex-1 text-left"
  }, /*#__PURE__*/React.createElement("span", {
    title: studyDescription,
    className: "text-base text-gray-800 dark:text-gray-200 font-semibold block truncate w-full"
  }, studyDescription), submission.acr_transaction_id && /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-gray-600 dark:text-gray-400 font-normal"
  }, submission.acr_transaction_id)), /*#__PURE__*/React.createElement(SubmissionStatusBadge, {
    status: submission.status,
    acrStatus: submission.acr_status,
    validationErrors: submission.acr_validation_errors
  })), examDate && /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600 dark:text-gray-400"
  }, examDate)));
};
export default SubmissionPreviewCard;